export default __webpack_public_path__ + "static/media/bg-footer.b2985138.svg";